module.exports = __webpack_public_path__ + "fonts/dsiccc2020930.23eb70a6.woff";